import { render } from "./AboutTechnologyPage.vue?vue&type=template&id=39f019df&scoped=true"
import script from "./AboutTechnologyPage.vue?vue&type=script&lang=js"
export * from "./AboutTechnologyPage.vue?vue&type=script&lang=js"

import "./AboutTechnologyPage.vue?vue&type=style&index=0&id=39f019df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f019df"]])

export default __exports__